import React from 'react';
import { CalendarCheckIcon } from 'lucide-react';
import { Button } from './ui/Button';
import { Field } from './ui/Field';
import { useLeadForm } from '../hooks/useLeadForm';
import { treatmentAreas } from '../data/content';
interface MatchFormProps {
  onDark?: boolean;
  submitLabel?: string;
  compact?: boolean;
}
export function MatchForm({
  onDark = false,
  submitLabel = 'Match me with a provider',
  compact = false
}: MatchFormProps) {
  const {
    fields,
    errors,
    status,
    setField,
    submit
  } = useLeadForm({
    require: ['name', 'email', 'phone', 'zip']
  });
  const onSubmit = (event: React.FormEvent) => {
    event.preventDefault();
    void submit();
  };
  if (status === 'success') {
    return <div className={`py-8 text-center ${onDark ? 'text-white' : 'text-ash-900'}`} role="status" data-id="element-110" data-mp="mqk3oz3lkcd0">
        <span className="mx-auto flex h-14 w-14 items-center justify-center rounded-full bg-turq-400 text-ash-900" data-id="element-111" data-mp="7tt16gymmkj6">
          <CalendarCheckIcon className="h-7 w-7" aria-hidden="true" data-id="element-112" data-mp="crujgzo8aftl" />
        </span>
        <h3 className="mt-5 font-display text-2xl" data-id="element-113" data-mp="34z1fptpt1qf0">You&apos;re on the list, {fields.name}</h3>
        <p className={`mx-auto mt-2 max-w-sm text-sm leading-relaxed ${onDark ? 'text-white/70' : 'text-ash-600'}`} data-id="element-114" data-mp="301j7k5jm3f82">
          A certified provider near {fields.zip} will reach out within one business day to schedule your free
          consultation. Watch for a call from a local number.
        </p>
      </div>;
  }
  return <form onSubmit={onSubmit} noValidate className="flex flex-col gap-4" data-id="element-115" data-mp="2m9utvxtpsioz">
      <div className={compact ? 'grid gap-4' : 'grid gap-4 sm:grid-cols-2'} data-id="element-116" data-mp="2hbb9i1urreyq">
        <Field label="Full name" value={fields.name} onChange={v => setField('name', v)} placeholder="Jane Whitmore" autoComplete="name" error={errors.name} onDark={onDark} data-id="element-117" data-mp="2v26l3lwnka60" />
        <Field label="Email address" type="email" inputMode="email" value={fields.email} onChange={v => setField('email', v)} placeholder="jane@email.com" autoComplete="email" error={errors.email} onDark={onDark} data-id="element-118" data-mp="22jj7ssnwdzfh" />
        <Field label="Phone number" type="tel" inputMode="tel" value={fields.phone} onChange={v => setField('phone', v)} placeholder="(555) 018-8420" autoComplete="tel" error={errors.phone} onDark={onDark} data-id="element-119" data-mp="6fuvbnfucen7" />
        <Field label="Zip code" value={fields.zip} onChange={v => setField('zip', v.replace(/\D/g, '').slice(0, 5))} placeholder="85251" inputMode="numeric" autoComplete="postal-code" error={errors.zip} onDark={onDark} data-id="element-120" data-mp="3jor9omlzflq9" />
      </div>
      <Field label="Area you'd like treated (optional)" value={fields.area} onChange={v => setField('area', v)} options={treatmentAreas.map(a => a.name)} onDark={onDark} data-id="element-121" data-mp="13y4rb5n70xtx" />
      <Button type="submit" size="lg" variant={onDark ? 'accent' : 'primary'} disabled={status === 'loading'} className="mt-1 w-full" data-id="element-122" data-mp="2tdp8v3e229vl">
        {status === 'loading' ? 'Matching you…' : submitLabel}
      </Button>
      <p className={`text-center text-xs ${onDark ? 'text-white/55' : 'text-ash-500'}`} data-id="element-123" data-mp="2epufrlw4y3hz">
        By submitting you agree to be contacted about a consultation. No obligation, and we never sell your
        information.
      </p>
    </form>;
}